import type {
  BaselineDigitalData,
  GlobalContext,
  OutboundDigitalData,
} from '../types/digital-data';

const FORBIDDEN_TOP_LEVEL_KEYS = new Set(['page', 'user']);

function getTopLevelPathKey(path: string): string {
  const match = path.match(/^([^.\[]+)/);
  return match?.[1] ?? path;
}

/** Protects coordinator-owned page, user, and property context from action patches. */
export function isForbiddenPatchPath(path: string): boolean {
  const topLevel = getTopLevelPathKey(path);

  if (FORBIDDEN_TOP_LEVEL_KEYS.has(topLevel)) {
    return true;
  }

  if (
    topLevel === 'global' &&
    (path === 'global' ||
      path.startsWith('global.page') ||
      path.startsWith('global.user') ||
      path.startsWith('global.property'))
  ) {
    return true;
  }

  return false;
}

/** Replaces the caller global with a snapshot of coordinator-owned context. */
export function overlayAuthoritativeGlobals(
  target: BaselineDigitalData,
  authoritativeGlobal: GlobalContext
): OutboundDigitalData {
  return {
    ...target,
    global: structuredClone(authoritativeGlobal),
  };
}
